import { getApiClientVigo } from './ApiClientVigo.js'



/**
 * Bestätigt Daten über den Legacy-Endpunkt
 * @param {string} code1 - Code 1 aus der URL
 * @param {string} code2 - Code 2 aus der URL
 * @param {string} kanal - Kanal-Parameter
 * @param {string} funktion - Funktions-Parameter
 * @returns {Promise<{success: boolean, nachricht: string}>}
 */
export async function bestaetigenLegacy(code1, code2, kanal, funktion) {
    const client = getApiClientVigo()

    console.log('[LegacyService] Bestätige Daten (Legacy) mit code1:', code1, 'code2:', code2, 'kanal:', kanal, 'funktion:', funktion)

    try {
        // Nur Parameter mit Wert mitschicken (null/undefined/'' werden ausgelassen)
        const params = {}
        if (code1 != null && code1 !== '') params.code1 = code1
        if (code2 != null && code2 !== '') params.code2 = code2
        if (kanal != null && kanal !== '') params.kanal = kanal
        if (funktion != null && funktion !== '') params.funktion = funktion

        const response = await client.get('/v2/Tarifrechner/emailbestaetigenlegacy', {
            params,
            validateStatus: (status) => status >= 200 && status < 500
        })

        console.log('[LegacyService] Response Status:', response.status)
        console.log('[LegacyService] Response Data:', response.data)

        if (response.status === 200 && response.data?.ok === true) {
            return {
                success: true,
                nachricht: response.data?.nachricht || 'Daten erfolgreich bestätigt.'
            }
        }

        return {
            success: false,
            nachricht: response.data?.nachricht || 'Bestätigung fehlgeschlagen.'
        }

    } catch (error) {
        console.error('[LegacyService] Fehler:', error)
        return {
            success: false,
            nachricht: 'Ein Netzwerkfehler ist aufgetreten. Bitte versuchen Sie es später erneut.'
        }
    }
}
